import React from "react";
import { useInView } from "react-intersection-observer";
import "./styles.css";

const RotatingPlus = () => {
  const { ref, inView } = useInView({ triggerOnce: true });

  return (
    <div ref={ref} className={`plus-symbol ${inView ? "spin" : ""}`}>
      +
    </div>
  );
};

export default RotatingPlus;
